'use client';
import CDNImage from '@/components/cdnImage/cdnImage';
import { imageUtil } from '@/utils/imageUtil';
import { Fragment } from 'react';

import Player from '@/components/player';
import RichComponent from '@/components/product/richComponent';

export default function GraphCollapse({ detailData, isInApp }: any) {
  const detailModule = detailData?.data?.graphDetailsModule;

  const graphDetailList1_1 = detailModule?.specificationPartList?.[0]?.attributePartList || [];
  const graphDetailList1_2 = detailModule?.extendPartList?.[0]?.attributePartList || [];

  const specificationGroupName =
    detailModule?.specificationPartList?.[0]?.['C-P#Specification&specificationBasic']
      ?.specificationGroupName || 'Specifications';
  const graphDetailList1 = graphDetailList1_2.concat(graphDetailList1_1);

  const {
    wareTextIntroduction: graphDetail3,
    wareImageIntroductionTitle,
    wareTextIntroductionTitle,
    wareImageIntroduction,
    wareTextImportantInfo,
    wareTextImportantInfoTitle,
    videoList: wareVideoList,
  } = detailModule?.['C-M#viewGraphicDetailsItem&productIntroduction'] || {};
  const { brandStoryData } = detailModule || {};

  // const videoList: Array<{
  //   posterUrl: string;
  //   videoUrl: string;
  // }> = serviceDetail?.data?.graphDetailsModule?.["C-M#viewGraphicDetailsItem&productIntroduction"]?.videoList || [];
  // const videoList = [{
  //   posterUrl: 'http://imgdownload2.joybuy-test.com/da/s256x256_jfsintlxingyuntest-000-da/t1/4294967296/65536/1113873911995/49192/678db0b3E91031abc/b853b8a46c93f496.jpg!q70.webp',
  //   videoUrl: "https://intl-xingyun-testutccbucket.s3.cn-north-1.jdcloud-oss.com/140/4c1f7a6atransbjintl-xingyun-testutccbucket/26b21497977671047945912321/v.f30.mp4?dockingId=afe69ff7-73b5-418f-bcbe-5d19651a737f1",
  // },
  // {
  //   posterUrl: 'http://imgdownload2.joybuy-test.com/da/s256x256_jfsintlxingyuntest-000-da/t1/4294967296/65536/1113873911995/49192/678db0b3E91031abc/b853b8a46c93f496.jpg!q70.webp',
  //   videoUrl: "https://intl-xingyun-testutccbucket.s3.cn-north-1.jdcloud-oss.com/140/4c1f7a6atransbjintl-xingyun-testutccbucket/26b21497977671047945912321/v.f30.mp4?dockingId=afe69ff7-73b5-418f-bcbe-5d19651a737f1",
  // },
  // {
  //   posterUrl: 'http://imgdownload2.joybuy-test.com/da/s256x256_jfsintlxingyuntest-000-da/t1/4294967296/65536/1113873911995/49192/678db0b3E91031abc/b853b8a46c93f496.jpg!q70.webp',
  //   videoUrl: "https://intl-xingyun-testutccbucket.s3.cn-north-1.jdcloud-oss.com/140/4c1f7a6atransbjintl-xingyun-testutccbucket/26b21497977671047945912321/v.f30.mp4?dockingId=afe69ff7-73b5-418f-bcbe-5d19651a737f1",
  // }
  // ];

  return (
    <>
      <div>
        {
          <div
          // className={`${activeCollapse?.["3"] ? 'active' : ''}`}
          >
            <h2
            // className="pd-title-item"
            >
              <span>{wareTextIntroductionTitle || wareImageIntroductionTitle}</span>
            </h2>
            <div
            // className="graph-content"
            >
              {/* 纯图结构 */}
              <div
              // className="ware-image-wrapper"
              >
                {wareImageIntroduction?.map((wareImage: string, index: number) => {
                  const imgSrc = imageUtil.concatImgUrlWithoutForceHttps(
                    wareImage,
                    undefined,
                    undefined,
                    70,
                    process.env.NEXT_PUBLIC_IMAGE_CDN_DOMAIN?.split(','),
                  );
                  return (
                    <CDNImage
                      key={index}
                      src={imgSrc}
                      width={343}
                      height={228}
                      alt={wareTextIntroductionTitle || wareImageIntroductionTitle}
                      style={{ maxWidth: '100%' }}
                    />
                  );
                })}
              </div>
              <RichComponent data={graphDetail3} />
              {wareVideoList?.map((videoItem: any, index: number) => {
                const { videoUrl, posterUrl } = videoItem || {};
                if (!videoUrl) {
                  return;
                }
                return (
                  <Player
                    key={`${videoUrl}-${index}`}
                    url={videoUrl}
                    width={382}
                    height={228}
                    playerConfig={{
                      file: {
                        attributes: {
                          controlsList: 'nodownload', // 禁用下载
                          disablePictureInPicture: true, // 禁用画中画
                          muted: true,
                          autoPlay: false,
                        },
                      },
                    }}
                    poster={posterUrl}
                  />
                );
              })}
            </div>
          </div>
        }
        {/* 重要信息 */}
        {wareTextImportantInfo && (
          <div
          // className={`${activeCollapse?.["2"] ? 'active' : ''}`}
          >
            <h2
            // className="pd-title-item"
            >
              <span>{wareTextImportantInfoTitle}</span>
            </h2>
            <div
            // className="important-info-content"
            >
              <RichComponent data={wareTextImportantInfo} />
            </div>
          </div>
        )}

        {/* 品牌故事 */}
        {brandStoryData && (
          <div
          // className={`${activeCollapse?.["4"] ? 'active' : ''}`}
          >
            <h2
            // className="pd-title-item"
            >
              <span>{brandStoryData?.title}</span>
            </h2>
            <div
            // className="brand-content"
            >
              {brandStoryData?.data?.map((item: any, index: number) => {
                return (
                  <Fragment key={index}>
                    {item.type === '0' ? (
                      <CDNImage src={item.graphicUrl} width={343} height={228} alt='brand image' />
                    ) : (
                      <div dangerouslySetInnerHTML={{ __html: item.textualDetail }}></div>
                    )}
                  </Fragment>
                );
              })}
            </div>
          </div>
        )}
        {/* Specifications */}
        {graphDetailList1.length > 0 ? (
          <div
          // className={`${activeCollapse?.["1"] ? 'active' : ''}`}
          >
            <h2
            // className="pd-title-item"
            >
              <span>{specificationGroupName}</span>
            </h2>
            {
              <div
              // className="spec-content"
              >
                {graphDetailList1.map((item: any, index: number) => {
                  return (
                    <Fragment key={index}>
                      <div
                      // className="grid-item"
                      >
                        {item?.['C-P#Attribute&attributeBasic']?.attributeName}
                      </div>
                      <div
                      // className="grid-item"
                      >
                        {item?.['C-P#Attribute&attributeBasic']?.attributes}
                      </div>
                    </Fragment>
                  );
                })}
              </div>
            }
          </div>
        ) : null}
      </div>
    </>
  );
}
